import { Navigate } from "react-router-dom";

const AuthMiddleware = ({ children }) => {
  const isAuthUser = sessionStorage.getItem(process.env.REACT_APP_AUTHENTICATION_KEY)
    
  if (!isAuthUser) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default AuthMiddleware;
